import { createEffect } from 'effector';
import { api } from '../../api/axiosInstance.js';

export const getOCHVBinsFx = createEffect().use(async ({ bins, table }) => {
  const binsStr = bins.map((item) => `gov_ids=${item}`).join('&');
  return (
    await api().get(
      `/mmf-payer/?page=${table.page}&limit=${table.limit}${
        bins.length > 0 ? `&${binsStr}` : ''
      }`
    )
  ).data;
});
